import { $sceneMap } from '@stores/dataStores';
import { type STImageMarker, SceneType } from '@types';
import cn from '@utils/cn';
import { useMemo } from 'react';

interface Props {
  marker: STImageMarker;
  className?: string;
}

export function ImageMarkerSubtitle({ marker, className }: Props) {
  const subTitle = useMemo(() => {
    const type = $sceneMap.getState().get(marker.data.sceneId!)?.type;
    if (type === SceneType.pano) return '全景图片';
    if (type === SceneType.panoVideo) return '全景视频';
    if (type === SceneType.matrix) return '高清矩阵';
    return '';
  }, [marker.data.sceneId]);

  return (
    <div className={cn('flex-shrink-0 text-sm text-black-gray', className)}>
      {subTitle}
    </div>
  );
}
